/* My Acre JS — moved out of snippets/atc-banner.liquid on 16 Sep 2026 (Claude) so it caches instead of
   re-downloading inside every page's HTML. The <link>/<script> stays at the same position in the
   snippet, so the cascade and the execution order are unchanged. */
(function () {
  if (window.__maObBanner) return; window.__maObBanner = 1;
  function init() {
    var ob = document.querySelector('[data-ma-ob]'); if (!ob) return;
    var banner = document.querySelector('[data-atc-banner]') || document.querySelector('.atc-banner--container'); if (!banner) return;
    var hideTimer = null;
    function money(cents) { return '$' + (cents / 100).toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
    function hideBanner() {
      banner.classList.remove('visible');
      banner.style.position = ''; banner.style.left = ''; banner.style.right = '';
      banner.style.bottom = ''; banner.style.top = ''; banner.style.width = ''; banner.style.zIndex = '';
      if (banner.parentElement) banner.parentElement.style.display = 'none';
      if (hideTimer) { clearTimeout(hideTimer); hideTimer = null; }
    }
    function showBanner(row) {
      var img = row.querySelector('.ma-ob__media img'),
          name = row.querySelector('.ma-ob__name'),
          price = row.querySelector('.ma-ob__price');
      var bImg = banner.querySelector('[data-atc-banner-product-image]'),
          bTitle = banner.querySelector('[data-atc-banner-product-title]'),
          bOpts = banner.querySelector('[data-atc-banner-product-options]'),
          bQty = banner.querySelector('[data-atc-banner-product-price-quantity]'),
          bVal = banner.querySelector('[data-atc-banner-product-price-value]'),
          bSub = banner.querySelector('[data-atc-banner-cart-subtotal]'),
          bCount = banner.querySelector('[data-atc-banner-cart-button] span');
      if (bImg) {
        bImg.innerHTML = '';
        if (img) { var im = new Image(); im.src = img.getAttribute('src'); im.alt = ''; im.style.width = '100%'; im.style.height = '100%'; im.style.objectFit = 'cover'; bImg.appendChild(im); }
      }
      if (bTitle && name) bTitle.textContent = (name.textContent || '').trim();
      if (bOpts) bOpts.textContent = '';
      if (bQty) bQty.textContent = '1 × ';
      if (bVal && price) bVal.textContent = (price.textContent || '').trim();
      fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
        if (bSub) bSub.textContent = money(c.total_price);
        if (bCount) bCount.textContent = c.item_count;
      }).catch(function () {});
      if (banner.parentElement) banner.parentElement.style.display = 'block';
      banner.style.position = 'fixed'; banner.style.left = '0'; banner.style.right = '0';
      banner.style.bottom = '0'; banner.style.top = 'auto'; banner.style.width = '100%'; banner.style.zIndex = '700';
      banner.classList.remove('animating'); banner.classList.add('visible');
      if (hideTimer) clearTimeout(hideTimer);
      hideTimer = setTimeout(hideBanner, 5000);
    }
    var closeBtn = banner.querySelector('[data-atc-banner-close]');
    if (closeBtn) closeBtn.addEventListener('click', hideBanner);
    ob.querySelectorAll('[data-ma-ob-add]').forEach(function (btn) {
      var row = btn.closest('.ma-ob__row') || ob;
      var was = btn.classList.contains('is-added');
      new MutationObserver(function () {
        var now = btn.classList.contains('is-added');
        if (now && !was) showBanner(row);
        was = now;
      }).observe(btn, { attributes: true, attributeFilter: ['class'] });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
